import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import withBackSupport from 'components/HOCs/withBackSupport';
import PAGES from 'constants/pages';
import { loadData } from 'store/pages/actions';
import { selectPageData, selectPageIsLoading } from 'store/pages/selectors';
import Details, { IDetailsProps } from 'components/Details';

type MatchParamsType = {
  type: string;
  id: string;
};

const DetailsPage = () => {
  const dispatch = useDispatch();
  const { params } = useRouteMatch<MatchParamsType>();
  const pageId = PAGES.DETAILS;
  const data = useSelector(state =>
    selectPageData(state, { pageId, params }),
  ) as IDetailsProps['data'];

  const isLoading = useSelector(state => selectPageIsLoading(state, { pageId, params }));

  useEffect(() => {
    if (!data) dispatch(loadData({ pageId: PAGES.DETAILS, params }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return <Details data={data} isLoading={isLoading} />;
};

export default withBackSupport(DetailsPage);
